<template>
  <div class="container">
    <div class="content-wrapper">
      <div class="page-header">
        <h1>地址管理</h1>
      </div>

      <!-- 操作按钮 -->
      <div class="action-bar">
        <el-button
            type="primary"
            @click="handleAdd"
            :disabled="address.data.length >= 5"
        >
          新增地址
        </el-button>
        <el-button @click="getAddress">
          刷新
        </el-button>
        <span v-if="address.data.length >= 5" class="limit-tip">
          最多只能添加5个地址
        </span>
      </div>

      <!-- 表格区域 -->
      <div class="table-card">
        <el-table
            :data="address.data"
            stripe
            style="width: 100%"
            v-loading="loading"
        >
          <el-table-column prop="contact_name" label="联系人" width="120"/>
          <el-table-column prop="telephone" label="联系电话" width="150"/>
          <el-table-column prop="detail_address" label="详细地址" min-width="200"/>
          <el-table-column prop="building_number" label="门牌号" width="120"/>
          <el-table-column label="是否默认" width="100">
            <template #default="scope">
              <el-tag :type="scope.row.is_default ? 'success' : 'info'">
                {{ scope.row.is_default ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="240">
            <template #default="scope">
              <el-button link type="primary" size="small" @click="handleEdit(scope.row)">
                编辑
              </el-button>
              <el-button link type="danger" size="small" @click="handleDelete(scope.row)">
                删除
              </el-button>
              <el-button v-if="!scope.row.is_default" link type="success" size="small"
                         @click="handleSetDefault(scope.row)">
                设为默认
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 添加/编辑地址 Dialog -->
      <el-dialog
          v-model="dialogVisible"
          :title="dialogTitle"
          width="30rem"
          @close="handleDialogClose"
      >
        <el-form
            ref="formRef"
            :model="form"
            :rules="formRules"
            label-width="100px"
        >
          <el-form-item label="联系人" prop="contact_name">
            <el-input v-model="form.contact_name" placeholder="请输入联系人姓名" style="width: 70%"/>
          </el-form-item>
          <el-form-item label="联系电话" prop="telephone">
            <el-input v-model="form.telephone" placeholder="请输入联系电话" style="width: 70%"/>
          </el-form-item>
          <el-form-item label="详细地址" prop="detail_address">
            <el-input
                v-model="form.detail_address"
                placeholder="请输入详细地址"
                readonly
                @click="openAddressDrawer"
                style="width: 70%"
            >
              <template #suffix>
                <el-icon class="search-icon">
                  <Search/>
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="门牌号" prop="building_number">
            <el-input v-model="form.building_number" placeholder="例如1层101室" style="width: 70%"/>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">确定</el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 地址搜索抽屉 -->
      <el-drawer
          v-model="addressDrawerVisible"
          title="搜索地址"
          :size="400"
      >
        <div class="address-search-drawer">
          <el-input
              v-model="addressSearchKeyword"
              placeholder="请输入地址关键词"
              clearable
              @input="handleAddressSearchInput"
          >
            <template #prefix>
              <el-icon>
                <Search/>
              </el-icon>
            </template>
          </el-input>

          <div class="address-list" v-loading="addressSearchLoading">
            <div
                v-for="(item, index) in addressSearchResults"
                :key="index"
                class="address-item"
                @click="selectAddress(item)"
            >
              <div class="address-name">{{ item.name || item.address }}</div>
              <div class="address-detail" v-if="item.address && item.address !== item.name">
                {{ item.address }}
              </div>
            </div>
            <div v-if="addressSearchKeyword && addressSearchResults.length === 0 && !addressSearchLoading"
                 class="empty-tip">
              未找到相关地址
            </div>
            <div v-if="!addressSearchKeyword" class="empty-tip">
              请输入地址关键词进行搜索
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  padding-top: 12rem;
  padding-bottom: 4rem;
  background: #f5f6fa;
  min-height: calc(100vh - 11rem);
}

.content-wrapper {
  margin: auto;
  width: 90%;
  max-width: 1200px;
  padding: 2rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.action-bar {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.limit-tip {
  color: #f56c6c;
  font-size: 14px;
}

.table-card {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.search-icon {
  cursor: pointer;
  color: #909399;
}

.search-icon:hover {
  color: #409eff;
}

.address-search-drawer {
  padding: 1rem;
}

.address-list {
  margin-top: 1.5rem;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.address-item {
  padding: 1rem;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.address-item:hover {
  background-color: #f5f7fa;
}

.address-item:last-child {
  border-bottom: none;
}

.address-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.25rem;
}

.address-detail {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 2rem;
  color: #909399;
  font-size: 14px;
}
</style>
<script setup>
import apiClient from "@/components/plugins/axios";
import axios from "axios";
import {reactive, ref, onMounted} from "vue";
import {ElMessage, ElMessageBox} from 'element-plus';
import {Search} from '@element-plus/icons-vue';

const loading = ref(false)
const dialogVisible = ref(false)
const dialogTitle = ref('新增地址')
const formRef = ref(null)

const form = reactive({
  id: null,
  location: {
    longitude: 0,
    latitude: 0
  },
  detail_address: '',
  building_number: '',
  contact_name: '',
  telephone: '',
})

const address = reactive({
  data: [],
  total: 0
})

// 地址搜索抽屉相关
const addressDrawerVisible = ref(false)
const addressSearchKeyword = ref('')
const addressSearchResults = ref([])
const addressSearchLoading = ref(false)
let addressSearchTimer = null

// 验证联系电话格式（支持手机和座机号）
const validatePhone = (rule, value, callback) => {
  const phone = value.trim()
  // 手机：11位数字，1开头
  const mobilePattern = /^1[3-9]\d{9}$/
  // 座机号：区号（3-4位）- 号码（7-8位），如 010-12345678 或 021-12345678
  const landlinePattern = /^0\d{2,3}-?\d{7,8}$/

  if (mobilePattern.test(phone) || landlinePattern.test(phone)) {
    callback()
  } else {
    callback(new Error('请输入正确的联系电话'))
  }
}

// 打开地址搜索抽屉
function openAddressDrawer() {
  addressDrawerVisible.value = true
  addressSearchKeyword.value = ''
  addressSearchResults.value = []
}

// 地址搜索输入（带防抖）
function handleAddressSearchInput() {
  const keyword = addressSearchKeyword.value?.trim()

  // 如果关键词为空，清空结果
  if (!keyword) {
    addressSearchResults.value = []
    return
  }

  // 清除之前的定时器
  if (addressSearchTimer) {
    clearTimeout(addressSearchTimer)
  }

  // 设置防抖延迟（500ms）
  addressSearchTimer = setTimeout(async () => {
    addressSearchLoading.value = true
    try {
      const postStr = JSON.stringify({
        keyWord: keyword,
        queryType: '1',
        start: '0',
        count: '5',
        level: '12',
        mapBound: '-180,-90,180,90'
      })

      const params = {
        postStr: postStr,
        tk: '6be7dce2a710f766dfd12e55ded745f9'
      }

      const res = await axios.get('http://api.tianditu.gov.cn/v2/search', {params})
      // 处理搜索结果
      if (res.data && res.data.pois) {
        addressSearchResults.value = res.data.pois
      } else {
        addressSearchResults.value = []
      }
    } catch (error) {
      addressSearchResults.value = []
    } finally {
      addressSearchLoading.value = false
    }
  }, 500)
}

// 选择地址
function selectAddress(item) {
  form.detail_address = item.address
  form.location.longitude = item.lonlat.split(',')[0]
  form.location.latitude = item.lonlat.split(',')[1]
  addressDrawerVisible.value = false
}

// 表单验证规则
const formRules = reactive({
  contact_name: [
    {required: true, message: '请输入联系人姓名', trigger: 'blur'}
  ],
  telephone: [
    {required: true, message: '请输入联系电话', trigger: 'blur'},
    {validator: validatePhone, trigger: 'blur'}
  ],
  detail_address: [
    {required: true, message: '请输入详细地址', trigger: 'change'}
  ]
})

// 获取地址列表
async function getAddress() {
  loading.value = true
  try {
    const res = await apiClient.get('/api/v1/address/')
    if (res.data.code === 200) {
      address.data = res.data.data || []
      address.total = res.data.count || 0
    } else {
      ElMessage.error({
        message: res.data.message || '获取地址列表失败',
        duration: 1000
      })
    }
  } catch (error) {
    ElMessage.error({
      message: '获取地址列表失败，请稍后重试',
      duration: 1000
    })
  } finally {
    loading.value = false
  }
}

// 打开新增对话框
function handleAdd() {
  // 检查地址数量限制
  if (address.data.length >= 5) {
    ElMessage.warning({
      message: '最多只能添加5个地址，请先删除不需要的地址',
      duration: 1000
    })
    return
  }
  dialogTitle.value = '新增地址'
  resetForm()
  // 自动填充用户信息
  loadUserInfoToForm()
  dialogVisible.value = true
}

// 打开编辑对话框
function handleEdit(row) {
  dialogTitle.value = '编辑地址'
  form.id = row.id
  form.contact_name = row.contact_name || ''
  form.telephone = row.telephone || ''
  form.detail_address = row.detail_address || ''
  form.building_number = row.building_number || ''
  form.location.longitude = row.location?.longitude || 0
  form.location.latitude = row.location?.latitude || 0
  dialogVisible.value = true
}

// 设置默认地址
async function handleSetDefault(row) {
  try {
    const res = await apiClient.put('/api/v1/address/set/default/' + row.id)
    if (res.data.code === 200) {
      ElMessage.success({
        message: '设置默认地址成功',
        duration: 1000
      })
      await getAddress()
    } else {
      ElMessage.error({
        message: res.data.message || '设置失败',
        duration: 1000
      })
    }
  } catch (error) {
    ElMessage.error({
      message: '设置失败，请稍后重试',
      duration: 1000
    })
  }
}

// 删除地址
async function handleDelete(row) {
  try {
    await ElMessageBox.confirm(
        '确定要删除这个地址吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
    )

    const res = await apiClient.delete('/api/v1/address/' + row.id)
    if (res.data.code === 200) {
      ElMessage.success({
        message: '删除成功',
        duration: 1000
      })
      await getAddress()
    } else {
      ElMessage.error({
        message: res.data.message || '删除失败',
        duration: 1000
      })
    }
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error({
        message: '删除失败，请稍后重试',
        duration: 1000
      })
    }
  }
}

// 提交表单（新增或编辑）
async function handleSubmit() {
  if (!formRef.value) return

  await formRef.value.validate(async (valid) => {
    if (!valid) return

    // 如果是新增，检查地址数量限制
    if (!form.id && address.data.length >= 5) {
      ElMessage.warning({
        message: '最多只能添加5个地址，请先删除不需要的地址',
        duration: 1000
      })
      return
    }

    try {
      const data = {
        contact_name: form.contact_name,
        telephone: form.telephone,
        detail_address: form.detail_address,
        building_number: form.building_number,
        location: form.location
      }

      let res
      if (form.id) {
        // 编辑
        res = await apiClient.put('/api/v1/address/' + form.id, data)
      } else {
        // 新增
        res = await apiClient.post('/api/v1/address', data)
      }

      if (res.data.code === 200) {
        ElMessage.success({
          message: form.id ? '编辑成功' : '新增成功',
          duration: 1000
        })
        dialogVisible.value = false
        getAddress()
      } else {
        ElMessage.error({
          message: res.data.message || '操作失败',
          duration: 1000
        })
      }
    } catch (error) {
      ElMessage.error({
        message: '操作失败，请稍后重试',
        duration: 1000
      })
    }
  })
}

// 从userInfo加载信息到表单
function loadUserInfoToForm() {
  try {
    const cached = localStorage.getItem('userInfo')
      const parsed = JSON.parse(cached)
      if (parsed.name) {
        form.contact_name = parsed.name
      }
      if (parsed.telephone) {
        form.telephone = parsed.telephone
      }
  } catch (e) {
    // ignore parse error
  }
}

// 重置表单
function resetForm() {
  form.id = null
  form.contact_name = ''
  form.telephone = ''
  form.detail_address = ''
  form.building_number = ''
  form.location.longitude = 0
  form.location.latitude = 0
  if (formRef.value) {
    formRef.value.clearValidate()
  }
}

// 关闭对话框
function handleDialogClose() {
  resetForm()
}

onMounted(() => {
  getAddress()
  // 加载用户信息到表单
  loadUserInfoToForm()
})
</script>